import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CateringHero = () => {
  return (
    <section className="relative h-[500px] overflow-hidden">
      <Image
        src="https://images.unsplash.com/photo-1555244162-803834f70033"
        alt="Professional catering setup with beautifully arranged Mexican dishes and elegant presentation"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center px-4"
        >
          <div className="inline-flex items-center space-x-2 bg-accent px-4 py-2 rounded-full mb-6">
            <Icon name="ChefHat" size={20} className="text-accent-foreground" />
            <span className="text-accent-foreground font-body font-bold">CATERING SERVICES</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-white mb-6">
            Catering That <span className="text-primary">Impresses</span>
          </h1>
          
          <p className="text-xl text-white/90 font-body max-w-2xl mx-auto">
            Bring Kahlovera's bold Mexican flavors to your next event. From corporate gatherings to private celebrations, we deliver exceptional food and service.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CateringHero;